import React, { useMemo } from "react";
import { generateObjectId } from "../../../utils/objectIdUtils";
import GridLayout from "react-grid-layout";
import FieldTag from "../FieldTags/FieldTag";
import useElementDimensions from "../../../hooks/useElementDimensions";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import Label from "../../../components/FormComponents/Label";

const NewFormGridLayout = ({
  layout,
  fieldMap,
  parentId = "outer_layout",
  onChange,
  renderHoverActions // 👈 new prop
}) => {
  const [dimensions, containerRef] = useElementDimensions();

  const handleLayoutChange = (newLayout) => {
    const updatedLayout = {
      ...layout,
      [parentId]: newLayout
    };
    onChange?.(updatedLayout);
  };

  const renderItem = (item) => {
    const field = fieldMap[item.i];
    if (!field) return null;

    const hasNestedLayout = layout[item.i] !== undefined;

    return (
      <div key={item.i} className="single_field_render">
        <div className="form-buttons">{renderHoverActions && renderHoverActions(field, parentId)}</div>

        <MaterialIcon name={getFieldIcon(field.type)} className="mr_3" style={{ color: "#667085" }} />

        <div className="form_element_container">
          {hasNestedLayout ? (
            <>
              <Label>
                {field.label}
                {field.validate?.required && <span>*</span>}
              </Label>
              <NewFormGridLayout
                layout={layout}
                fieldMap={fieldMap}
                parentId={item.i}
                onChange={onChange}
                renderHoverActions={renderHoverActions}
              />
            </>
          ) : (
            <FieldTag key={item.i} element={field} />
          )}
        </div>
      </div>
    );
  };

  const currentLayout = useMemo(() => layout?.[parentId] || [], [layout, parentId]);

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <GridLayout
        cols={12}
        rowHeight={120}
        width={dimensions.width || 500}
        layout={currentLayout}
        compactType="vertical"
        style={{
          minHeight: "100px",
          height: "100%",
          paddingTop: "8px",
          border: parentId !== "outer_layout" && "2px dashed #e4e7ec"
        }}
        isDroppable
        droppingItem={{ i: generateObjectId(), h: 1, w: 12 }}
        useCSSTransforms
        isResizable
        onDragStart={(_, __, ___, ____, e) => e.stopPropagation()}
        onLayoutChange={handleLayoutChange}
      >
        {currentLayout.map(renderItem)}
      </GridLayout>
    </div>
  );
};

export default NewFormGridLayout;
